import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const get = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/delivery-order`,
  })

  return response?.data
}

export const remove = async (fleetTaskId, orderId) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/delivery-order/${orderId}`,
  })

  return response?.data
}

export const update = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'PUT',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/delivery-order`,
    data,
  })

  return response?.data
}

export const transfer = async (fleetTaskId, orderId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/delivery-order/${orderId}/transfer`,
    data,
  })

  return response?.data
}

export const bulkTransfer = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/transfer`,
    data,
  })

  return response?.data
}
